<template>
  <div>
    <CRow class="content-fade-in">
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <div class="note">
              <strong>Ghi chú:</strong>
              <div class="group-content-note">
                <div>
                  Dấu <span class="required">*</span> là bắt buộc phải điền
                </div>
                <div>
                  Tài khoản tối thiểu 6, tối đa 100 kí tự bao gồm chữ thường và
                  số
                </div>
                <div>
                  Mật khẩu tối thiểu 8, tối đa 128 kí tự bao gồm chữ hoa, chữ
                  thường, số và kí tự đặc biệt là 1 trong số kí tự này @$!%*?&
                </div>
                <div>
                  Số điện thoại gồm 10 kí tự và đúng định số điện thoại nước
                  Việt Nam không bao gồm SĐT cố định. Ví dụ: 033*****00 hoặc
                  8433*****00
                </div>
                <div>Email phải đúng định dạng. Ví dụ: demo@com.vn</div>
              </div>
            </div>
          </CCardHeader>
          <CCardBody>
            <CForm class="form-basic" v-on:submit.prevent>
              <CRow>
                <CCol xs="12" sm="12" md="8" lg="8" xl="8">
                  <CRow>
                    <CCol xs="12" sm="12" md="6" lg="6" xl="6">
                      <BaseSelect :options="rolesSelect.options" :data="rolesSelect.data" ref="rolesSelect">
                      </BaseSelect>
                    </CCol>
                    <CCol xs="12" sm="12" md="6" lg="6" xl="6">
                      <BaseSelect :options="categorySelect.options" :data="categorySelect.data" ref="categorySelect">
                      </BaseSelect>
                    </CCol>
                    <CCol sm="6" md="6" xl="6">
                      <BaseInput :options="userNameInput.options" :data="userNameInput.data" />
                    </CCol>
                    <CCol sm="6" md="6" xl="6">
                      <BaseInput :options="fullNameInput.options" :data="fullNameInput.data" />
                    </CCol>
                    <CCol sm="6" md="6" xl="6">
                      <BaseInput :options="phoneInput.options" :data="phoneInput.data" />
                    </CCol>
                  </CRow>
                </CCol>
                <CCol xs="12" sm="12" md="4" lg="4" xl="4">
                  <CRow>
                    <CCol sm="12" md="12" xl="12">
                      <div class="form-group form-input-wrapper">
                        <label>Hệ thống <span class="required">*</span></label><br />
                        <div class="form-control" style="height: 100% !important">
                          <div v-for="each in systemsInput.data.items" :key="each.id"
                            class="user custom-control custom-checkbox" :class="{
                              'input-valid-error':
                                systemsInput.data.validator &&
                                !systemsInput.data.validator.isValid,
                            }">
                            <input type="checkbox" class="custom-control-input" v-model="systemsInput.data.model"
                              :value="each.value" :id="each.text" />
                            <label class="custom-control-label mr-3" :for="each.text" style="padding-top: 1px">{{
                                each.text
                            }}</label>
                          </div>
                        </div>
                        <div class="valid-error" v-show="!systemsInput.data.validator.isValid">
                          {{ systemsInput.data.validator.errorMessage }}
                        </div>
                      </div>
                    </CCol>
                  </CRow>
                </CCol>
              </CRow>
              <CRow>
                <CCol xs="12" sm="4" md="4" lg="4" xl="4">
                  <BaseInput :options="emailInput.options" :data="emailInput.data" />
                </CCol>
                <CCol xs="12" sm="4" md="4" lg="4" xl="4">
                  <BaseSelect :options="isEnabledSelect.options" :data="isEnabledSelect.data" ref="isEnabledSelect">
                  </BaseSelect>
                </CCol>
                <!-- <CCol xs="12" sm="4" md="4" lg="4" xl="4">
                  <BaseSelect
                    :options="orgSelect.options"
                    :data="orgSelect.data"
                    ref="orgSelect"
                  ></BaseSelect>
                </CCol> -->
              </CRow>
              <div slot="footer" class="mt-4">
                <CButton color="primary" class="btn-action-primary mr-2" @click="submitData()">
                  <i class="fa fa-refresh"></i> Cập nhật
                </CButton>
                <CButton color="secondary" class="btn-action-primary" @click="$router.go(-1)"><i
                    class="fa fa-reply"></i> Hủy bỏ
                </CButton>
              </div>
              <BaseLoading :loading="loading.value"></BaseLoading>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import BaseSelect from "../base/BaseSelect2";
import BaseInput from "../base/BaseInput";
import BaseLoading from "../base/BaseFormLoading";

export default {
  name: "UserUpdate",
  components: { BaseSelect, BaseInput, BaseLoading },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
    showErrorMsg: {
      type: "error",
      title: "Errors",
    },
    showWarningMsg: {
      type: "warn",
      title: "warn",
    },
  },
  data: function () {
    let that = this;
    return {
      loading: { value: false },
      userInfo: null,
      idField: {
        data: {
          model: that.$route.params.id,
          name: "id",
        },
      },
      rolesSelect: {
        options: {
          label: "Nhóm người dùng tài khoản <span class='required'>*</span>",
          selectAllText: "Chọn nhóm người dùng tài khoản",
          filter: false,
          'keyField': 'value',
          'valueField': 'text',
        },
        data: {
          model: "",
          name: 'role',
          source: {
            url: "/role/listRole",
            response: function (dataResponse) {
              return dataResponse.data;
            }
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.rolesSelect.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Nhóm người dùng không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          },
        }
      },
      /* Username */
      userNameInput: {
        options: {
          label: "Tên đăng nhập <span class='required'>*</span>",
          placeholder: "Tên đăng nhập",
          type: "text",
          readonly: true,
        },
        data: {
          name: "username",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
        },
      },
      /* Password */
      // passwordInput: {
      //   options: {
      //     label: "Mật khẩu *",
      //     placeholder: "Mật khẩu",
      //     type: "password"
      //   },
      //   data: {
      //     name: "password",
      //     model: "",
      //   }
      // },
      /* IsEnable */
      isEnabledSelect: {
        options: {
          label: "Trạng thái <span class='required'>*</span>",
          placeholder: "Trạng thái",
          filter: false,
        },
        data: {
          name: "enabled",
          items: [
            { key: "1", value: "Hoạt động" },
            { key: "0", value: "Vô hiệu hóa" },
          ],
          model: "",
          updateCallback: function () {
            that.submitData();
          },
        },
      },
      // orgSelect: {
      //   options: {
      //     label: "Đơn vị <span class='required'>*</span>",
      //     selectAllText: "Chọn đơn vị",
      //     filter: false,
      //     keyField: "value",
      //     valueField: "text",
      //   },
      //   data: {
      //     model: "",
      //     name: "orgId",
      //     source: {
      //       url: "/organization/list-org-active",
      //       response: function (dataResponse) {
      //         return dataResponse.data;
      //       },
      //     },
      //     validator: {
      //       isValid: true,
      //       errorMessage: "",
      //       valid: function () {
      //         let value = that.orgSelect.data.model;
      //         if (value == null || value === "") {
      //           this.isValid = false;
      //           this.errorMessage = "Đơn vị không được để trống";
      //         } else {
      //           this.isValid = true;
      //           this.errorMessage = "";
      //         }
      //         return this.isValid;
      //       },
      //     },
      //   },
      // },
      /* FullName */
      fullNameInput: {
        options: {
          label: "Họ Tên <span class='required'>*</span>",
          placeholder: "Họ và tên",
        },
        data: {
          name: "fullName",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.fullNameInput.data.model;
              let fullname_regex =
                /^[a-zA-Z_ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀẾỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪếễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹý ]+$/;
              if (value === "" || value === null) {
                this.isValid = false;
                this.errorMessage = "Họ và tên không được để trống";
              } else if (fullname_regex.test(value) == false) {
                this.isValid = false;
                this.errorMessage = "Họ và tên không đúng định dạng";
              } else if (fullname_regex.test(value) == true) {
                this.isValid = true;
              }
              return this.isValid;
            },
          },
        },
      },
      /* Phone */
      phoneInput: {
        options: {
          label: "Số điện thoại <span class='required'>*</span>",
          placeholder: "Số điện thoại",
          type: "number",
        },
        data: {
          name: "phone",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.phoneInput.data.model;
              let phone_regex = /^(0[3|5|7|8|9])+([0-9]{8})$/;
              let phone_regex2 = /^(84[3|5|7|8|9])+([0-9]{8})$/;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Số điện thoại không được để trống";
              } else if (
                phone_regex.test(value) == false &&
                phone_regex2.test(value) == false
              ) {
                this.isValid = false;
                this.errorMessage = "Số điện thoại sai định dạng";
              } else if (
                phone_regex.test(value) == true ||
                phone_regex2.test(value) == true
              ) {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            },
          },
        },
      },

      /* Email */
      emailInput: {
        options: {
          label: "Email <span class='required'>*</span>",
          placeholder: "Email",
        },
        data: {
          name: "email",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.emailInput.data.model;
              let email_regex =
                /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Email không được để trống";
              } else if (email_regex.test(value) == false) {
                this.isValid = false;
                this.errorMessage = "Email không đúng định dạng";
              } else if (email_regex.test(value) == true) {
                this.isValid = true;
              }
              return this.isValid;
            },
          },
        },
      },
      /* Category */
      categorySelect: {
        options: {
          label: "Chức vụ tài khoản <span class='required'>*</span>",
          filter: false,
          keyField: "value",
          valueField: "text",
        },
        data: {
          model: "",
          name: "categoryId",
          source: {
            url: "/category-user/category-active",
            response: function (dataResponse) {
              return dataResponse.data;
            },
          },
          validator: {
            isValid: true,
            errorMessage: "",
          },
        },
      },
      /* System */
      systemsInput: {
        data: {
          name: "systems",
          model: [],
          items: [],
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.systemsInput.data.model;
              if (value === undefined || value.length === 0) {
                this.isValid = false;
                this.errorMessage = "Vui lòng chọn hệ thống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            },
          },
        },
      },
    };
  },
  methods: {
    loadDataSystems() {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/system/listSystemActive",
        successCallback: function (response) {
          that.systemsInput.data.items = response.data.data;
          that.loading.value = false;
          that.loadData();
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        },
      });
    },
    loadData() {
      let that = this;
      this.$helper.loadDataSource({
        // loading: that.loading,
        url: "/users/findById",
        isJsonContentType: false,
        dataSubmit: function () {
          return { id: that.idField.data.model };
        },
        successCallback: function (response) {
          // let convertUsername = response.data.data.username.split('_');
          response.data.data.username = response.data.data.username;
          response.data.data.enabled =
            response.data.data.enabled == true ? 1 : 0;
          // that.userNameInput.options.append = convertUsername[1];
          that.dataCache = that.userInfo = response.data.data;
          that.$helper.setupDataResponse(that.$data, response.data.data);
          // that.loading.value = false
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
          // that.loading.value = false
        },
      });
    },
    submitData: function () {
      let that = this;
      let isValid = true;
      isValid &= this.phoneInput.data.validator.valid();
      isValid &= this.emailInput.data.validator.valid();
      isValid &= this.systemsInput.data.validator.valid();
      isValid &= this.fullNameInput.data.validator.valid();
      // isValid &= this.orgSelect.data.validator.valid();
      if (!isValid) {
        return;
      }
      let dataRequest = {
        id: this.idField.data.model,
        phone: this.phoneInput.data.model,
        email: this.emailInput.data.model,
        systems: this.systemsInput.data.model,
        enabled: this.isEnabledSelect.data.model == 0 ? false : true,
        categoryId: this.categorySelect.data.model,
        fullName: this.fullNameInput.data.model,
        role: this.rolesSelect.data.model
        // orgId: this.orgSelect.data.model
      };

      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/users/updateUser",
        type: "PUT",
        dataValid: function () {
          return that.dataCache;
        },
        dataSubmit: function () {
          return dataRequest;
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({
              message: that.$helper.getStringError(response.data.data),
            });
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({ message: "Cập nhật tài khoản thành công" });
            that.$router.go(-1);
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        },
      });
    },
  },
  computed: {},
  created() { },
  mounted() {
    this.loadDataSystems();
  },
  watch: {
    "systemsInput.data.model": function () {
      this.systemsInput.data.validator.valid();
    },
  },
};
</script>
